import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import { StoreWelcomeImage } from "../../assets/webp";
import { StoreImgCustomize, StoreImgLaunch, StoreImgName, StoreImgUpload } from "../../assets/svgs";
import Typography from "../../components/Typography/Typography";
// import FlatButtons from "../../components/FlatButton/FlatButton";
import { AIAssistantModal } from "../../components/ArtificialAssistance";
import { StoreAIBot } from "../../components/StoreAIBot";
import { useNavigate } from "react-router";
import AnimatedButton from "../../components/AnimatedButton";
import { useDispatch } from "react-redux";
import { resetStoreState } from "../../redux/slices/createProductSlice";
import { resetStore } from "../../redux/slices/createStoreSlice";

export const StoreWelcomeScreen: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetStoreState());
    dispatch(resetStore());
  }, [dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate()

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={styles.welcomeContainer}>
        <div className={styles.leftPanel}>
          <img
            src={StoreWelcomeImage}
            alt="Virtual Store"
            className={styles.storeImage}
          />
          <div className={styles.imageOverlay}></div>
          <div className={styles.bottomTextOverlay}>
            <Typography
              variant='heading3'
              fontFamily="satoshi"
              weight="bold"
              className={styles.overlayTitle}>
              Creator-Made Virtual Spaces
            </Typography>
            <Typography
              variant="bodyRegular"
              fontFamily="satoshi"
              weight="bold"
              className={styles.overlaySubtitle}>
              Join thousands of artists and creators building their digital presence
            </Typography>
          </div>
        </div>

        <div className={styles.rightPanel}>
          <div className={styles.contentWrapper}>
            <Typography
              variant="heading2"
              fontFamily="satoshi"
              weight="bold"
              className={styles.mainTitle}>
              Welcome to Your Creative Journey
            </Typography>
            <Typography
              variant="bodyRegular"
              fontFamily="satoshi"
              weight="bold"
              className={styles.description}>
              Create your own immersive digital storefront in minutes. Showcase your
              art, products, and creativity in a whole new dimension.
            </Typography>

            <div className={styles.featuresSection}>
              <Typography
                variant="heading5"
                fontFamily="satoshi"
                weight="bold"
                className={styles.featuresTitle}>
                What you'll do:
              </Typography>
              <div className={styles.featuresList}>
                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <img
                      src={StoreImgName}
                      alt="Welcome Name Icon"
                      className={styles.icon}
                    />
                  </div>
                  <Typography
                    variant="bodyRegular"
                    fontFamily="satoshi"
                    weight="regular"
                    className={styles.featureText}>
                    Name and brand your virtual shop
                  </Typography>
                </div>
                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <img
                      src={StoreImgUpload}
                      alt="Welcome Upload Icon"
                      className={styles.icon}
                    />
                  </div>
                  <Typography
                    variant="bodyRegular"
                    fontFamily="satoshi"
                    weight="regular"
                    className={styles.featureText}>
                    Upload your products or digital art
                  </Typography>
                </div>
                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <img
                      src={StoreImgCustomize}
                      alt="Welcome Customize Icon"
                      className={styles.icon}
                    />
                  </div>
                  <Typography
                    variant="bodyRegular"
                    fontFamily="satoshi"
                    weight="regular"
                    className={styles.featureText}>
                    Customize your immersive space
                  </Typography>
                </div>
                <div className={styles.featureItem}>
                  <div className={styles.featureIcon}>
                    <img
                      src={StoreImgLaunch}
                      alt="Welcome Launch Icon"
                      className={styles.icon}
                    />
                  </div>
                  <Typography
                    variant="bodyRegular"
                    fontFamily="satoshi"
                    weight="regular"
                    className={styles.featureText}>
                    Launch and share with the world
                  </Typography>
                </div>
              </div>
            </div>

            <div className={styles.buttonGroup}>
              <AnimatedButton
                variant="primary"
                onClick={() => {
                  // window.location.href = '/choose-template';
                  navigate('/choose-template')

                }}
                className={styles.primaryButton}>
                <Typography
                  variant="buttonText"
                  fontFamily="satoshi"
                  weight="regular"
                  size="base"
                  className={styles.primaryButtonText}>
                  Get Started
                </Typography>
              </AnimatedButton>

              <StoreAIBot />
            </div>
          </div>
        </div>
      </div>

      <AIAssistantModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
};